import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { UpstreamVirtualConnectionTablesFilteredByFieldQuery, UpstreamVirtualConnectionTablesFilteredByFieldQueryVariables, VirtualConnectionTablesDisplayGridRowDataFragment, VirtualConnectionTableSortOrder, WorkbookUpstreamVirtualConnectionTablesQuery, WorkbookUpstreamVirtualConnectionTablesQueryVariables , UpstreamVirtualConnectionTablesFilteredByFieldDocument , WorkbookUpstreamVirtualConnectionTablesDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, MaxCountsResultData, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { VirtualConnectionTablesDisplayGrid } from '../sharedDisplayGrid/VirtualConnectionTablesDisplayGrid';
import { VirtualConnectionTablesValidSortFields } from '../sorting/sortProviders/VirtualConnectionTablesGridSortProvider';
import { getRowDataWithMaxCountsForVirtualConnectionTable } from '../table/functions/VirtualConnectionTableRowDataFunctions';
import { VirtualConnectionTablesDisplayGridRowData } from '../table/types/VirtualConnectionTablesDisplayGridRowData';

type QueryVariables = WorkbookUpstreamVirtualConnectionTablesQueryVariables;
type QueryResults = WorkbookUpstreamVirtualConnectionTablesQuery;
type QueryResultListNode = VirtualConnectionTablesDisplayGridRowDataFragment;
type GridRowData = VirtualConnectionTablesDisplayGridRowData;

type QueryVariablesWithFilter = UpstreamVirtualConnectionTablesFilteredByFieldQueryVariables;
type QueryResultsWithFilter = UpstreamVirtualConnectionTablesFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.workbooks && resultData.workbooks[0] && resultData.workbooks[0].upstreamVirtualConnectionTablesConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return (
    resultData &&
    resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes &&
    resultData.fieldsConnection.nodes[0] &&
    resultData.fieldsConnection.nodes[0].upstreamVirtualConnectionTablesConnection
  );
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.workbooks && resultData.workbooks[0];
}

function selectMaxCountsResultForFilteredQuery(resultData: QueryResultsWithFilter): MaxCountsResultData {
  return resultData && resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes && resultData.fieldsConnection.nodes[0];
}

function getRowDataForVirtualConnectionTable(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnectionTable(node, selectMaxCountsResult(resultData));
}

function getRowDataForVirtualConnectionTableForFilteredQuery(
  node: QueryResultListNode,
  resultData: QueryResultsWithFilter,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnectionTable(node, selectMaxCountsResultForFilteredQuery(resultData));
}

export type WorkbookUpstreamVirtualConnectionTablesQueryGridProps = GridSortProps<VirtualConnectionTablesValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
};

export function WorkbookUpstreamVirtualConnectionTablesQueryGrid(props: WorkbookUpstreamVirtualConnectionTablesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamVirtualConnectionTablesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredVirtualConnectionTablesLineageGridMessage();

  return props.filteredFieldId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={UpstreamVirtualConnectionTablesFilteredByFieldDocument}
      partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as VirtualConnectionTableSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForVirtualConnectionTableForFilteredQuery}
    >
      {({ rowStore }) => (
        <VirtualConnectionTablesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={WorkbookUpstreamVirtualConnectionTablesDocument}
      partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as VirtualConnectionTableSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnectionTable}
    >
      {({ rowStore }) => (
        <VirtualConnectionTablesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
